import { defaultInitialState } from 'utils/defaultInitialState.ts.ts';
import { createFormBasedSliceReducers } from 'utils/redux.ts';
import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import {
    SupplyRequestMaterialForEdit,
    SupplyRequestMaterialListForEdit,
    SupplyRequestMaterialsSliceInitialState
} from 'components/Supply/SupplyRequests/PageBody/List/SupplyRequestListEdit.types.ts';
import {
    supplyRequestEditFormBodyInitialState
} from 'components/Supply/SupplyRequests/PageBody/List/SupplyRequestListEdit.utils.ts';
import { FindSupplyRequestStatusResponseDto } from 'store/api/supplyRequestStatus.tsx';
import { FindSupplyRequestResponseDto } from 'store/api/supplyRequest.tsx';
import { FindSupplyRequestMaterialListByMaterialResponseDto } from 'store/api/supplyRequestMaterial.tsx';

const supplyRequestMaterialsSliceInitialState: SupplyRequestMaterialsSliceInitialState = {
    ...defaultInitialState,
    editableFormBody: supplyRequestEditFormBodyInitialState,
    materialsSort: '',
    materialsFilter: '',
    materialsByStageForEdit: [],
    materialsByMaterialForEdit: [],
    supplyRequestStatuses:  undefined,
    supplyRequestData: undefined,
    selectedMaterial: undefined,
}

const reducers = createFormBasedSliceReducers<any>()

export const supplyRequestMaterialsSlice = createSlice({
    name: 'supplyRequestMaterials',
    initialState: supplyRequestMaterialsSliceInitialState,
    reducers: {
        ...reducers,
        setMaterialsFilter: (state: Draft<SupplyRequestMaterialsSliceInitialState>, action: PayloadAction<string>) => {
            state.materialsFilter = action.payload
        },
        setMaterialsSort: (state: Draft<SupplyRequestMaterialsSliceInitialState>, action: PayloadAction<string>) => {
            state.materialsSort = action.payload
        },
        setMaterialsByStageForEdit: (state: Draft<SupplyRequestMaterialsSliceInitialState>, action: PayloadAction<SupplyRequestMaterialListForEdit[]>) => {
            state.materialsByStageForEdit = action.payload
        },
        setMaterialsByMaterialForEdit: (state: Draft<SupplyRequestMaterialsSliceInitialState>, action: PayloadAction<FindSupplyRequestMaterialListByMaterialResponseDto[]>) => {
            state.materialsByMaterialForEdit = action.payload
        },
        setSupplyRequestStatuses: (state: Draft<SupplyRequestMaterialsSliceInitialState>, action: PayloadAction<FindSupplyRequestStatusResponseDto[]>) => {
            state.supplyRequestStatuses = action.payload
        },
        setSupplyRequestData:  (state: Draft<SupplyRequestMaterialsSliceInitialState>, action: PayloadAction<FindSupplyRequestResponseDto>) => {
            state.supplyRequestData = action.payload
        },
        setSelectedMaterial:  (state: Draft<SupplyRequestMaterialsSliceInitialState>, action: PayloadAction<SupplyRequestMaterialForEdit | undefined>) => {
            state.selectedMaterial = action.payload
        },
    }
}
)


export default supplyRequestMaterialsSlice.reducer